import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../shared.module';

import { DashboardComponent } from 'src/app/pages/dashboard/dashboard.component';
import { StateWiseDistribution } from 'src/app/components/sections/state-wise-distribution/state-wise-distribution.component';
import { DepartmentService } from 'src/app/components/sections/department-service/department-service.component';
import { TopDepartmentService } from 'src/app/components/sections/top-department-service/top-department-service.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { YearWiseComponent } from 'src/app/components/sections/year-wise/year-wise.component';
import { TopListComponent } from 'src/app/components/sections/top-list/top-list.component';
import { ChartFullscreenComponent } from 'src/app/components/utility/chart-fullscreen/chart-fullscreen.component';
import { AvailedSchemeGraphSvgComponent } from 'src/app/components/layout/svg/availed-scheme-graph-svg.component';
import { AvailedServicesGraphSvgComponent } from 'src/app/components/layout/svg/availed-services-graph-svg.component';
import { IssuedDocumentsGraphSvgComponent } from 'src/app/components/layout/svg/issued-documents-graph-svg.component';
import { TotalUsersGraphSvgComponent } from 'src/app/components/layout/svg/total-users-graph-svg.component';
import { IssuedDocumentsSvgComponent } from '../../components/layout/svg/issued-documents-svg.component';
import { TotalUsersSvgComponent } from '../../components/layout/svg/total-users-svg.component';
import { AvailedSchemeSvgComponent } from 'src/app/components/layout/svg/availed-scheme-svg.component';

const dashboardRoutes: Routes = [
  { path: '', component: DashboardComponent },
  { path: 'shared', component: DashboardComponent },
];

@NgModule({
  declarations: [
    DashboardComponent,
    StateWiseDistribution,
    TopDepartmentService,
    DepartmentService,
    YearWiseComponent,
    TopListComponent,
    ChartFullscreenComponent,
  ],
  imports: [
    RouterModule.forChild(dashboardRoutes),
    CommonModule,
    SharedModule,
    LeafletModule,
    AvailedSchemeGraphSvgComponent,
    AvailedServicesGraphSvgComponent,
    IssuedDocumentsGraphSvgComponent,
    TotalUsersGraphSvgComponent,
    IssuedDocumentsGraphSvgComponent,
    IssuedDocumentsSvgComponent,
    TotalUsersSvgComponent,
    AvailedSchemeSvgComponent,
  ],
})
export class DashboardModule {}
